export class SidenavMenu {
    constructor(public id: number,
                public title: string,
                public groupTitle: string,
                public routerLink: string,
                public href: string,
                public target: string,
                public hasSubMenu: boolean,
                public parentId: number,
                public image:string
                ) { }
} 